import * as React from 'react';

import TaskItem from '../common/TaskItem';

import MainPageDefault from './MainPage.Default';
import MainPageContractor from './MainPage.Contractor';

import TaskModel from '../../models/Task';
import TrackedProject from '../common/TrackedProject';
import UserDetails from '../../models/UserDetails';
import Authorization from '../../util/Authorization';
import { UserRoles } from 'src/models/UserRole';
import { UserTypes } from 'src/models/UserType';
import { IRootState } from 'src/reducers';
import selectors from 'src/selectors';
import actions from 'src/actions';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

interface IMainPageStateProps {
    user: UserDetails;
    tasks: Array<TaskModel>;
    tasksIsLoading: boolean;
}

export interface IMainPageDispatchProps {
    loadTasks: () => void;
    navigate: (path: string) => void;
}

type MainPageProps = IMainPageStateProps & IMainPageDispatchProps;

class MainPage extends React.Component<MainPageProps> {
    constructor(props: MainPageProps) {
        super(props);

        this.getTaskItems = this.getTaskItems.bind(this);
        this.getTrackedProjects = this.getTrackedProjects.bind(this);
    }

    public componentDidMount() {
        if (Authorization.IsInRole(UserRoles.Admin, this.props.user)) {
            this.props.loadTasks();
        } else {
            this.props.loadTasks();
        }
    }

    private getTaskItems() {
        if (this.props.tasksIsLoading) {
            return [<TaskItem key="fake-task-1" />, <TaskItem key="fake-task-2" />];
        } else {
            return this.props.tasks.map((task: TaskModel) => <TaskItem key={`task-${task.id}`} task={task} />);
        }
    }

    private getTrackedProjects() {
        if (this.props.tasksIsLoading) {
            return [<TrackedProject key="fake-task-1" />, <TrackedProject key="fake-task-2" />];
        } else {
            let link = '';

            if (Authorization.IsInRole(UserRoles.Admin, this.props.user)) {
                link = '/clients/2/projects/1/tracts';
            } else {
                link = '/clients/2/projects/1';
            }

            const projects = [{ id: 1, name: 'Southwest', company: 'Southwest Project 1', link }];

            return projects.map((project: { id: number; name: string; company: string; link: string }) => (
                <TrackedProject key={`project-${project.id}`} project={project} navigate={this.props.navigate} />
            ));
        }
    }

    public render() {
        if (Authorization.IsInType(UserTypes.Landman, this.props.user)) {
            return (
                <MainPageContractor
                    taskItems={this.getTaskItems()}
                    trackedProjects={this.getTrackedProjects()}
                    tasksIsLoading={this.props.tasksIsLoading}
                />
            );
        } else {
            return (
                <MainPageDefault
                    taskItems={this.getTaskItems()}
                    trackedProjects={this.getTrackedProjects()}
                    tasksIsLoading={this.props.tasksIsLoading}
                />
            );
        }
    }
}

const mapStateToProps = (state: IRootState) => ({
    user: selectors.auth.user(state),
    tasksIsLoading: selectors.task.isLoading(state),
    tasks: selectors.task.tasks(state),
});

const mapDispatchToProps: IMainPageDispatchProps = {
    loadTasks: () => actions.task.getTasks(),
    navigate: (path: string) => push(path),
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);



// WEBPACK FOOTER //
// ./src/components/main/MainPage.tsx